import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabIIIA as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabIIIA = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const a1Field = () => {
    const propertyName = pn<AprResponseModel>("a1");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a1} {formatPercentTotal(props.data?.a1, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a2Field = () => {
    const propertyName = pn<AprResponseModel>("a2");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a2} {formatPercentTotal(props.data?.a2, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a3Field = () => {
    const propertyName = pn<AprResponseModel>("a3");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a3} {formatPercentTotal(props.data?.a3, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a4Field = () => {
    const propertyName = pn<AprResponseModel>("a4");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a4} {formatPercentTotal(props.data?.a4, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a5Field = () => {
    const propertyName = pn<AprResponseModel>("a5");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a5} {formatPercentTotal(props.data?.a5, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a6Field = () => {
    const propertyName = pn<AprResponseModel>("a6");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a6} {formatPercentTotal(props.data?.a6, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a7Field = () => {
    const propertyName = pn<AprResponseModel>("a7");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a7} {formatPercentTotal(props.data?.a7, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a8Field = () => {
    const propertyName = pn<AprResponseModel>("a8");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a8} {formatPercentTotal(props.data?.a8, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknownA9Field = () => {
    const propertyName = pn<AprResponseModel>("unknownA9");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknownA9} {formatPercentTotal(props.data?.unknownA9, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };
  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">
          Educational Status of Project Participants Aged 19 or Older (at time of first service in the reporting year) 
        </Typography>
        <Grid container spacing="lg">
          <Grid item xs={11}>
            <Grid container spacing="lg">
              {props.data?.a1 != null && (
                <Grid item xs={12}>
                  {a1Field()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.a2 != null && (
                <Grid item xs={12}>
                  {a2Field()}
                </Grid>
              )}

              {props.data?.a3 != null && (
                <Grid item xs={12}>
                  {a3Field()}
                </Grid>
              )}

              {props.data?.a4 != null && (
                <Grid item xs={12}>
                  {a4Field()}
                </Grid>
              )}

              {props.data?.a5 != null && (
                <Grid item xs={12}>
                  {a5Field()}
                </Grid>
              )}

              {props.data?.a6 != null && (
                <Grid item xs={12}>
                  {a6Field()}
                </Grid>
              )}

              {props.data?.a7 != null && (
                <Grid item xs={12}>
                  {a7Field()}
                </Grid>
              )}

              {props.data?.a8 != null && (
                <Grid item xs={12}>
                  {a8Field()}
                </Grid>
              )}

              {props.data?.unknownA9 != null && (
                <Grid item xs={12}>
                  {unknownA9Field()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

        </Grid>
      </Stack>
    </Card>
  );
};
